<template>
  <div class="cal-elec">
    <map-control
      :icon="calcSvg"
      title="电量计算"
      @click="visible = true"
    ></map-control>
    <el-dialog
      width="600px"
      title="电量计算"
      class="cal-elec-dialog"
      v-drag
      :modal="false"
      append-to-body
      :visible.sync="visible"
    >
      <div class="calc-content">
        <el-form
          label-position="right"
          label-width="130px"
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="机组型号" prop="turbineTypeId">
            <el-select
              class="calc-select"
              v-model="form.turbineTypeId"
              popper-class="wind-farm-select "
            >
              <el-option
                v-for="(item, index) in turbineTypeList"
                :key="index"
                :label="item.typeName"
                :value="item.turbineTypeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="K" prop="K">
            <el-input v-model="form.K" placeholder="请输入K参数"></el-input>
          </el-form-item>
          <el-form-item label="A（m/s）" prop="A">
            <el-input
              v-model="form.A"
              placeholder="请输入A参数"
              @input="
                val => {
                  handleParamsChange(val, 'A');
                }
              "
            ></el-input>
          </el-form-item>
          <el-form-item label="U（m/s）" prop="U">
            <el-input
              v-model="form.U"
              placeholder="请输入U参数"
              @input="
                val => {
                  handleParamsChange(val, 'U');
                }
              "
              >></el-input
            >
          </el-form-item>
          <el-form-item label="空气密度（kg/m³）" prop="density">
            <el-input
              v-model="form.density"
              placeholder="请输入密度"
            ></el-input>
          </el-form-item>
          <el-form-item label="尾流损失（%）" prop="flowLoss">
            <el-input
              v-model="form.flowLoss"
              placeholder="请输入尾流损失（%）"
            ></el-input>
          </el-form-item>
          <el-form-item label="综合折减系数（%）" prop="synthesizeLoss">
            <el-input
              v-model="form.synthesizeLoss"
              placeholder="请输入综合折减系数（%） 参考值60%～85%"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="calc-result">
          <div class="calc-text">
            <span>计算结果: 满发小时 </span
            ><span class="hour-space">{{ hour }}</span
            ><span>(h)</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="wind-stand-footer flex-reverse">
        <el-button type="text" @click="handleCalcClick">计算</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import calcSvg from '@/asset/windfarm/calc.svg';
import { number } from '@/utils/rules';
import MapControl from './map-control';

export default {
  components: {
    MapControl
  },
  data() {
    return {
      calcSvg,
      visible: false,
      timer: null,
      hour: '',
      form: {
        turbineTypeId: '',
        synthesizeLoss: '',
        flowLoss: '',
        density: '',
        // region: '',
        // type: '',
        K: '',
        A: '',
        U: ''
      },
      turbineTypeList: [],
      rules: {
        turbineTypeId: [
          { required: true, message: '请选择机组型号', trigger: 'blur' }
        ],
        A: [number({ required: true })],
        K: [number({ required: true })],
        U: [number({ required: true })],
        density: [number({ required: true })],
        flowLoss: [number({ required: true })],
        synthesizeLoss: [number({ required: true })]
      }
    };
  },
  methods: {
    handleNumberChange(val, target) {
      const res = val.replace(/\D*/g, '');
      this.form[target] = res;
    },
    handleParamsChange(val, type) {
      if (!val) {
        this.form.U = '';
        this.form.A = '';
        clearTimeout(this.timer);
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
        }

        if (!this.form.K) return;

        this.timer = setTimeout(
          this.$fetch
            .get('/windfarm/station/weibullAkuTool', {
              showError: true,
              params: {
                K: this.form.K,
                [type]: val
              }
            })
            .then(res => {
              const { data = {} } = res;

              const { U = '', K = '', A = '' } = data;

              if (type === 'A') {
                this.form.U = U;
              }
              if (type === 'U') {
                this.form.A = A;
              }
              this.form.K = K;
            }),
          1000
        );
      }
    },
    async getTurbineTypeList() {
      const { data } = await this.$fetch.get(
        '/windfarm/station/getTurbineTypeList'
      );
      this.turbineTypeList = data.turbineTypeList;
    },
    handleCalcClick() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$postForm('/windfarm/station/powerCalculationTool', {
            data: {
              ...this.form
            },
            showError: true,
            showSuccess: true
          }).then(res => {
            const { data } = res;

            const { fullLoadHour } = data;
            this.hour = fullLoadHour;
          });
        }
      });
    }
  },
  mounted() {
    this.getTurbineTypeList();
  }
};
</script>

<style lang="less" scoped>
.cal-elec {
  position: absolute;
  z-index: 1000;
  bottom: 132px;
  right: 10px;

  /deep/.map-control {
    img {
      margin-top: 2px;
    }
  }
}
</style>

<style lang="less">
.cal-elec-dialog {
  &.el-dialog__wrapper {
    overflow: hidden;
  }
  .el-dialog__footer {
    padding: 0;
  }

  .calc-content {
    color: #fff;
  }
  .calc-select {
    width: 100%;
    &.el-select {
      input {
        text-align: left;
      }
    }
  }
  .calc-result {
    padding: 0px 0px 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .calc-text {
      height: 30px;
      line-height: 30px;
      display: flex;
      font-size: 12px;
    }
  }
  .hour-space {
    text-align: center;
    border-bottom: 1px solid #fff;
    width: 100px;
    height: 25px;
  }

  .el-form-item__label {
    color: #fff;
    font-size: 12px;
  }

  .el-input {
    input {
      outline: none;
      height: 26px;
      background-color: transparent;
      border-color: transparent;
      border: none;
      border-bottom: 1px solid #fff;
      color: #fff;
      border-radius: 0;
      box-sizing: border-box;
    }
  }
}
</style>
